/*eslint-disable*/
import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import {
  Grid,
  Typography,
  TextField,
  Divider,
  Box,
  Paper,
  FormControl
} from "@mui/material";
import { STYLES } from "config";
import CustomDropDownPicker from "../../../components/CustomDropDownPicker";

const Publishing = forwardRef((props, ref) => {
  const { data, setvalue } = props;
  const [state, setstate] = useState(data || {});
  const [errors, setErrors] = useState({});
  console.log("Errors :", errors)
  useEffect(() => {
    setstate(data || {});
  }, [data]);

  const getTodaysDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');

    const todayFormatted = `${yyyy}-${mm}-${dd}`

    const updatedState = ({ ...state, startPublishing: todayFormatted });

    setstate(updatedState);
    setvalue(updatedState);

    return todayFormatted;
  };

  const updateData = (e) => {
    const updatedState = { ...state, [e.target.name]: e.target.value };
    setstate(updatedState);
    setvalue(updatedState);

    if (errors[e.target.name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const inputStyle = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#003366"
      },
      "&:hover fieldset": {
        borderColor: "#003366"
      }
    }
  };

  // Options for dropdowns
  const statusOptions = [
    { value: 1, label: "Published" },
    { value: 0, label: "Unpublished" }
  ];

  const accessOptions = [
    { value: "public", label: "Public" },
    { value: "private", label: "Private" },
    { value: "restricted", label: "Restricted" }
  ];

  // Categories options (simplified for example)
  const categoryOptions = [
    { value: "21", label: "Epping Industrial" },
    { value: "22", label: "Western Cape" },
    { value: "23", label: "Cape Town" }
    // Add more categories as needed...
  ];
  const handleDropdownChange = (name, value) => {
    const updatedState = { ...state, [name]: value };
    setstate(updatedState);
    setvalue(updatedState);

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };



  useImperativeHandle(ref, () => ({
    isValidated() {
      const { state: status, expiryDate, startPublishing, finishPublishing } = state;
      const newErrors = {};

      // Validate Status
      if (!status && status !== 0) {
        newErrors.state = "Status is required";
      }

      // Validate Dates
      if (!expiryDate || expiryDate === "") {
        newErrors.expiryDate = "Expiry Date is required";
      }
      if (!startPublishing || startPublishing === "") {
        newErrors.startPublishing = "Start Publishing is required";
      }
      if (!finishPublishing || finishPublishing === "") {
        newErrors.finishPublishing = "Finish Publishing is required";
      }

      // Optional: Validate date order
      if (startPublishing && finishPublishing) {
        if (new Date(startPublishing) > new Date(finishPublishing)) {
          newErrors.finishPublishing = "Finish Publishing must be after Start Publishing";
        }
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    }
  }));

  return (
    <Paper
      elevation={5}
      sx={{
        height: "60vh", // 50% of viewport height
        width: "100%", // 80% of viewport width
        maxWidth: "100%", // Optional: Limit maximum width
        // Optional: Limit maximum height
        p: 3,
      }}
    >
      <Typography
        variant="h5"
        gutterBottom
        sx={{ color: STYLES.WEB_APP_FONT_CLR }}
      >
        Publishing
      </Typography>
      <Divider sx={{ bgcolor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

      <Typography
        variant="body1"
        paragraph
        sx={{ color: STYLES.WEB_APP_FONT_CLR }}
      >
        This section allows you to manage the publishing details for the property listing.
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: STYLES.WEB_APP_FONT_CLR }}
      >
        <strong>Expiry Date</strong>: The date when the property listing will expire on Property24 and Private Property.
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: STYLES.WEB_APP_FONT_CLR }}
      >
        <strong>Finish Publishing</strong>: The date when the property listing will expire on the API Website.
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: STYLES.WEB_APP_FONT_CLR, mb: 2, marginTop: "5px" }}
      >
        Please ensure all required fields are completed before publishing.
      </Typography>

      <Divider sx={{ bgcolor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

      <Grid container spacing={2}>
        {/* Status */}
        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
          >
            Status<span style={{ color: "red" }}>*</span>
          </Typography>
        </Grid>
        <Grid item size={10}>
          <CustomDropDownPicker
            name="state"
            value={state?.state || "published"}
            onChange={(value) => handleDropdownChange("state", value)}
            options={statusOptions}
            error={!!errors.state}
            helperText={errors.state || ""}
            required
            sx={inputStyle}
          />
          {errors.state && (
            <Typography variant="caption" color="error">
              {errors.state}
            </Typography>
          )}
        </Grid>

        {/* Categories */}
        {/* <Grid item size={2}>
          <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
            Categories
          </Typography>
        </Grid>
        <Grid item size={10}>
          <CustomDropDownPicker
            name="catId"
            value={state?.catId || ''}
            onChange={updateData}
            options={categoryOptions}
            sx={inputStyle}
          />
        </Grid> */}

        {/* Tags */}
        {/* <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
          >
            Tags
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            size="small"
            fullWidth
            name="tags"
            value={state?.tags || ""}
            onChange={updateData}
            sx={inputStyle}
          />
        </Grid>

        {/* Notes */}
        {/* <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
          >
            Notes
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            fullWidth
            multiline
            rows={8}
            name="note"
            value={state?.note || ""}
            onChange={updateData}
            sx={{
              ...inputStyle,
              "& .MuiOutlinedInput-root": {
                height: "300px"
              }
            }}
          />
        </Grid> */}

        {/* Version Notes */}
        {/* <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
          >
            Version Notes
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            size="small"
            fullWidth
            name="versionNote"
            value={state?.versionNote || ""}
            onChange={updateData}
            sx={inputStyle}
          />
        </Grid> */}

        {/* Author's Alias */}
        {/* <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
          >
            Author's Alias
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            size="small"
            fullWidth
            name="authorAlias"
            value={state?.authorAlias || ""}
            onChange={updateData}
            sx={inputStyle}
          />
        </Grid> */}

        {/* Feature 
        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
          >
            Feature
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            size="small"
            fullWidth
            name="featured"
            value={state?.featured || ""}
            onChange={updateData}
            sx={inputStyle}
          />
        </Grid> */}

        {/* Expiry Date */}


        {/* Start Publishing */}
        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
          >
            Start Publishing<span style={{ color: "red" }}>*</span>
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            size="small"
            fullWidth
            type="date"
            name="startPublishing"
            value={state?.startPublishing ? state?.startPublishing : getTodaysDate()}
            onChange={updateData}
            sx={inputStyle}
            error={!!errors.startPublishing}
            helperText={errors.startPublishing || ""}
            required
            InputLabelProps={{
              shrink: true
            }}
          />
        </Grid>

        {/* Finish Publishing */}
        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
          >
            Finish Publishing<span style={{ color: "red" }}>*</span>
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            size="small"
            fullWidth
            type="date"
            name="finishPublishing"
            value={state?.finishPublishing || ""}
            onChange={updateData}
            sx={inputStyle}
            error={!!errors.finishPublishing}
            helperText={errors.finishPublishing || ""}
            required
            InputLabelProps={{
              shrink: true
            }}
          />
        </Grid>



        <Grid item size={2}>
          <Typography
            variant="body1"
            sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}
          >
            Expiry Date<span style={{ color: "red" }}>*</span>
          </Typography>
        </Grid>
        <Grid item size={10}>
          <TextField
            size="small"
            fullWidth
            type="date"
            name="expiryDate"
            value={state?.expiryDate || ""}
            onChange={updateData}
            error={!!errors.expiryDate}
            helperText={errors.expiryDate || ""}
            required
            sx={inputStyle}
            InputLabelProps={{
              shrink: true
            }}
          />
        </Grid>


        {/* Access */}
        {/* <Grid item size={2}>
          <Typography variant="body1" sx={{ mt: 1, color: STYLES.WEB_APP_FONT_CLR }}>
            Access
          </Typography>
        </Grid>
        <Grid item size={10}>
          <CustomDropDownPicker
            name="access"
            value={state?.access || 'public'}
            onChange={updateData}
            options={accessOptions}
            sx={inputStyle}
          />
        </Grid> */}
      </Grid>
    </Paper>
  );
});
export default Publishing;
